﻿import * as types from './mutation-types';
import documentManagerService from '../../../api/digitalValidation/documentManagerService';
import orderManagerService from '../../../api/digitalValidation/orderManagerService';

export const showAlert1 = ({ commit, state }, code) => {
    commit(types.SHOW_ALERT, code);
}

export const hideAlert = ({ commit, state }) => {
    commit(types.HIDE_ALERT);
}

export const hideModal = ({ commit, state }) => {
    commit(types.HIDE_MODAL);
}

export const updateValidState = ({ commit, state }, formState) => {
    var blockAllreadyInState = false;
    var existingBlocks = state.form;
    if (existingBlocks) {
        for (var i = 0; i < existingBlocks.length; i++) {
            if (existingBlocks[i].blockId == formState.blockId) {
                formState.index = i;
                commit(types.VALIDATE_FORM_BLOCK, formState);
                blockAllreadyInState = true;
                break;
            }
        }
    }
    if (!blockAllreadyInState) {
        commit(types.REGISTER_FORM_BLOCK, formState);
    }
}

export const updatePartialValidState = ({ commit, state }, formState) => {
    var blockAllreadyInState = false;
    var existingBlocks = state.form;
    if (existingBlocks) {
        for (var i = 0; i < existingBlocks.length; i++) {
            if (existingBlocks[i].blockId == formState.blockId) {
                formState.index = i;
                commit(types.VALIDATE_PARTIAL_BLOCK, formState);
                blockAllreadyInState = true;
                break;
            }
        }
    }
    if (!blockAllreadyInState) {
        commit(types.REGISTER_PARTIAL_BLOCK, formState);
    }
}

export const getDivaContracts = ({ commit, state }, data) => {
    commit(types.GET_DIVA_CONTRACTS, { 'loaderTitle': data.loaderTitle, 'loaderMessage': data.loaderMessage, 'popupMessage': data.popupMessage });

    documentManagerService.getTeliaContracts(
        data.orderId,
        data.documentId,
        data.dealerCode,
        data.channelType,
        data.fileName,
        (divaContracts) => commit(types.STORE_DIVA_CONTRACTS, divaContracts),
        (exception) => commit(types.SHOW_MODAL, { 'context': 'contracts', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': [], 'buttons': ['refresh'] }));
}

export const getDocumentsPdf = ({ commit, state }, data) => {
    commit(types.GET_DIVA_CONTRACTS, { 'loaderTitle': data.loaderTitle, 'loaderMessage': data.loaderMessage, 'popupMessage': data.popupMessage });
    documentManagerService.getDocumentsPdf(
        data.orderId,
        data.dealerCode,
        data.channelType,
        data.teliaFinanceContracts,
        data.fileName,
        (divaContracts) => commit(types.STORE_DIVA_CONTRACTS, divaContracts),
        (exception) => commit(types.SHOW_MODAL, { 'context': 'contracts', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': [], 'buttons': ['refresh'] }));
}

export const updatePortingDetails = ({ commit, state }, data) => {
    commit(types.GET_UPDATE_PORTING_DETAILS, { 'loaderTitle': data.loaderTitle, 'loaderMessage': data.loaderMessage, 'popupMessage': data.popupMessage });
    //data.porting.isSaved = true;

    orderManagerService.updatePortingDetails(
        data.orderId,
        data.dealerCode,
        data.localNumber,
        data.simNumber,
        data.porting.isEPoA,
        (portingDetails) => { commit(types.STORE_UPDATE_PORTING_DETAILS, portingDetails), saveChanges({ commit, state }, data, portingDetails) },
        (exception) => commit(types.SHOW_MODAL, { 'context': 'contracts', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': [], 'buttons': ['refresh'], 'refresh': true }));
}

export const saveChanges = ({ commit, state }, data, result) => {
    console.log(result)
    if (result === 'False') {
        data.porting.isSaved = true;
    }
}

export const signPortings = ({ commit, state }, data) => {
    commit(types.GET_SIGN_PORTINGS, { 'loaderTitle': data.loaderTitle, 'loaderMessage': data.loaderMessage, 'popupMessage': data.popupMessage });
    documentManagerService.signPortings(
        data,
        (signPortings) => commit(types.STORE_SIGN_PORTINGS, signPortings),
        (exception) => commit(types.SHOW_MODAL, { 'context': 'contracts', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': [], 'buttons': ['refresh'], 'refresh': false }));
}

export const signPortingsBtC = ({ commit, state }, data) => {
    commit(types.GET_SIGN_PORTINGS, { 'loaderTitle': data.loaderTitle, 'loaderMessage': data.loaderMessage, 'popupMessage': data.popupMessage });
    documentManagerService.signPortingsBtC(
        data,
        (signPortings) => commit(types.STORE_SIGN_PORTINGS, signPortings),
        (exception) => commit(types.SHOW_MODAL, { 'context': 'contracts', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': [], 'buttons': ['refresh'], 'refresh': false }));
}

export const signNonPortingContracts = ({ commit, state }, data) => {
    commit(types.GET_NON_PORTING_CONTRACTS,
        {
            'errorMessage': data.errorMessages.sign,
            'loaderTitle': data.loaderTitle,
            'loaderMessage': data.loaderMessage
        });

    documentManagerService.signNonPortingContracts(
        data.orderId,
        data.dealerCode,
        data.channelType,
        (signNonPortingContracts) => { commit(types.STORE_NON_PORTING_CONTRACTS, signNonPortingContracts); approveOrderByCustomer({ commit, state }, data) },
        (exception) => {
            commit(types.SHOW_MODAL,
                {
                    'context': 'contracts',
                    'errorState': true,
                    'icon': 'warning',
                    'showHeadline': false,
                    'messageContent': [],
                    'buttons': ['refresh']
                });
        });
}

export const approveOrderByCustomer = ({ commit, state }, data) => {
    commit(types.GET_APPROVE_ORDER_BY_CUSTOMER,
        {
            'errorMessage': data.errorMessages.approve,
            'loaderTitle': data.loaderTitle,
            'loaderMessage': data.loaderMessage
        });

    documentManagerService.approveOrderByCustomer(
        data.orderId,
        data.dealerCode,
        data.channelType,
        (approveOrderByCustomerResult) => {
            commit(types.STORE_APPROVE_ORDER_BY_CUSTOMER, approveOrderByCustomerResult)
        },
        (exception) => {
            commit(types.SHOW_MODAL,
                {
                    'context': 'contracts',
                    'errorState': true,
                    'icon': 'warning',
                    'showHeadline': false,
                    'messageContent': [],
                    'buttons': ['refresh']
                });
        });
}

export const navigateNext = ({ commit, state }, data) => {
    commit(types.JUMP_NEXT_PAGE);
}

export const signDocumentsBtC = ({ commit, state }, data) => {
    commit(types.GET_NON_PORTING_CONTRACTS_BTC,
        {
            'loaderTitle': data.loaderTitle,
            'loaderMessage': data.loaderMessage,
            'errorMessage': data.errorMessages.signContractsErrorMessage
        });

    documentManagerService.signDocumentsBtC(
        data.orderId,
        data.dealerCode,
        data.channelType,
        (signDocumentsBtC) => {
            commit(types.STORE_NON_PORTING_CONTRACTS, signDocumentsBtC), approveOrderBtC({ commit, state }, data)
        },
        (exception) => {
            commit(types.SHOW_MODAL,
                {
                    'context': 'contracts',
                    'errorState': true,
                    'icon': 'warning',
                    'showHeadline': false,
                    'messageContent': [],
                    'buttons': ['refresh']
                });
        });
}

export const approveOrderBtC = ({ commit, state }, data) => {
    // set loader messages and set default value for approve order error message
    commit(types.GET_APPROVE_ORDER_BY_CUSTOMER_BTC,
        {
            'loaderTitle': data.loaderTitle,
            'loaderMessage': data.loaderMessage,
            'errorMessage': data.errorMessages.approveOrderGeneralErrorMessage
        });

    documentManagerService.approveOrderBtC(
        data.orderId,
        data.dealerCode,
        data.channelType,
        (approveOrderByCustomerResult) => {
            commit(types.STORE_APPROVE_ORDER_BY_CUSTOMER, approveOrderByCustomerResult)
        },
        (exception) => {
            var errorMessage = null;
            if (exception === 'MISSING_DOWN_PAYMENT_PLAN') {
                errorMessage = data.errorMessages.approveOrderMissingDownPaymentPlanErrorMessage;
            } else if (exception === 'CREDIT_ACCOUNT_ORDER_VALIDATION_FAILED') {
                errorMessage = data.errorMessages.approveOrderCAValidationErrorMessage;
            } else {
                errorMessage = data.errorMessages.approveOrderGeneralErrorMessage
            }

            commit(types.SHOW_MODAL,
                {
                    'context': 'contracts',
                    'errorState': true,
                    'icon': 'warning',
                    'showHeadline': false,
                    'messageContent': [],
                    'buttons': ['refresh'],
                    'message': errorMessage
                });
        });
}

export const setPageOverview = ({ commit, state }, data) => {
    commit(types.GET_PAGE_OVERVIEW);
    commit(types.STORE_PAGE_OVERVIEW, data);
}
export const setDeliveryAddress = ({ commit, state }, data) => {
    commit(types.GET_DELIVERY_ADDRESS);
    commit(types.STORE_DELIVERY_ADDRESS, data);
}

export const uploadDocument = ({ commit, state }, data) => {
    commit(types.GET_UPLOAD_DOCUMENT, { 'loaderTitle': data.loaderTitle, 'loaderMessage': data.loaderMessage, 'popupMessage': data.popupMessage });

    const files = data.formData;
    const fReader = new FileReader();
    var documentName = data.documentName;
    var orderId = data.orderId;
    var telephoneNumber = data.telephoneNumber;

    fReader.onload = () => {
        var data = fReader.result,
            base64 = data.replace(/^[^,]*,/, ''),
            //  base64 = data,
            info = {
                documentName: documentName,
                document: base64,
                orderId: orderId,
                telephoneNumber: telephoneNumber

            };
        documentManagerService.uploadDocumentPdf(
            info,
            (uploadedDocument) => commit(types.STORE_UPLOAD_DOCUMENT, uploadedDocument),
            (exception) => commit(types.SHOW_MODAL, { 'context': 'contracts', 'errorState': true, 'icon': 'warning', 'showHeadline': false, 'messageContent': [], 'buttons': ['refresh'] }));
    }
    fReader.readAsDataURL(files);
}

// Cancel order DiVa
export const cancelWholeOrder = ({ commit, state }, data) => {
    commit(types.GET_CANCEL_ORDER, { 'loaderTitle': data.loaderTitle, 'loaderMessage': data.loaderMessage });

    orderManagerService.cancelOrder(data.orderId, data.dealerCode, data.channelType,
        (cancelWholeOrder) => commit(types.STORE_CANCEL_ORDER, cancelWholeOrder),
        (exception) => commit(types.SHOW_MODAL,
            {
                'context': 'cancelOrderDiva',
                'errorState': true,
                'icon': 'warning',
                'showHeadline': false,
                'messageContent': [],
                'buttons': ['refresh'],
                'message': data.errorMessage
            },
            exception
        ));
}

export const creditCardPayInitialize = ({ commit, state }, data) => {
    commit(types.GET_INIT_PAYMENT_LOADER, { 'loaderTitle': data.loaderTitle, 'loaderMessage': data.loaderMessage });

    orderManagerService.creditCardPayInitialize(data.orderId, data.returnUrl,
        (creditCardPayInitialize) => commit(types.GET_CREDIT_CARD_RETURN_URL, creditCardPayInitialize),
        (exception) => commit(types.SHOW_MODAL,
            {
                'context': 'creditCardPayError',
                'errorState': true,
                'icon': 'warning',
                'showHeadline': false,
                'messageContent': [],
                'buttons': ['refresh'],
                'message': data.errorMessage
            }
        ));
}

export const redirectToNetaxeptTerminal = ({ commit, state }, data) => {
    commit(types.GET_REDIRECT_TO_URL, { 'url': data.redirectUrl, loaderData: { 'loaderTitle': data.loaderTitle, 'loaderMessage': data.loaderMessage } });
}

export const redirectToDocumentsStepPage = ({ commit, state }, data) => {
    commit(types.GET_REDIRECT_TO_URL, { 'url': data.redirectUrl, loaderData: { 'loaderTitle': data.loaderTitle, 'loaderMessage': data.loaderMessage } });
}

export const redirectToConfirmationStepPage = ({ commit, state }, data) => {
    commit(types.GET_REDIRECT_TO_URL, { 'url': data.confirmationPageUrl, loaderData: { 'loaderTitle': data.loaderTitle, 'loaderMessage': data.loaderMessage } });
}

export const tryExecuteSigningDocumentsB2CAgain = ({ commit, state }, data) => {
    commit(types.GET_NON_PORTING_CONTRACTS_BTC,
        {
            'loaderTitle': data.loaderTitle,
            'loaderMessage': data.loaderMessage,
            'errorMessage': data.errorMessages.signContractsErrorMessage
        });

    documentManagerService.signDocumentsBtC(
        data.orderId, data.dealerCode, data.channelType,
        (signDocumentsBtC) => { commit(types.STORE_NON_PORTING_CONTRACTS, signDocumentsBtC), tryApproveOrderB2CAgain({ commit, state }, data) },
        (exception) => {
            commit(types.SHOW_MODAL,
                {
                    'context': 'contracts',
                    'errorState': true,
                    'icon': 'warning',
                    'showHeadline': false,
                    'messageContent': [],
                    'buttons': ['refresh']
                });
        });
}

export const tryApproveOrderB2CAgain = ({ commit, state }, data) => {
    commit(types.GET_APPROVE_ORDER_BY_CUSTOMER_BTC,
        {
            'loaderTitle': data.loaderTitle,
            'loaderMessage': data.loaderMessage,
            'errorMessage': data.errorMessages.approveOrderGeneralErrorMessage
        });

    documentManagerService.approveOrderBtC(
        data.orderId,
        data.dealerCode,
        data.channelType,
        (approveOrderByCustomerResult) => {
            commit(types.STORE_APPROVE_ORDER_BY_CUSTOMER, approveOrderByCustomerResult),
                redirectToConfirmationStepPage({ commit, state }, data)
        },
        (exception) => {
            var errorMessage = null;
            if (exception === 'MISSING_DOWN_PAYMENT_PLAN') {
                errorMessage = data.errorMessages.approveOrderMissingDownPaymentPlanErrorMessage;
            } else if (exception === 'CREDIT_ACCOUNT_ORDER_VALIDATION_FAILED') {
                errorMessage = data.errorMessages.approveOrderCAValidationErrorMessage;
            } else {
                errorMessage = data.errorMessages.approveOrderGeneralErrorMessage
            }

            commit(types.SHOW_MODAL,
                {
                    'context': 'contracts',
                    'errorState': true,
                    'icon': 'warning',
                    'showHeadline': false,
                    'messageContent': [],
                    'buttons': ['refresh'],
                    'message': errorMessage
                });
        });
}